import React, { useState } from "react";
import AccountCircle from "@mui/icons-material/AccountCircle";
import IconButton from "@mui/material/IconButton";
import {
  Modal,
  Paper,
  Button,
  Typography,
  Box,
  useMediaQuery,
  createTheme,
  SvgIconOwnProps,
} from "@mui/material";
import { SvgIcon } from "@mui/material";
import { CommonProps } from "@mui/material/OverridableComponent";
import { JSX } from "react/jsx-runtime";
import { Persona } from "../../logic/domain/entities/persona";

interface UsrMenuProps {
  onLogoutFromMenu: () => void;  // Se recibe la función de logout como prop
  user:Persona
}

const UsrMenu: React.FC<UsrMenuProps> = ({ onLogoutFromMenu,user }) => {
  const theme = createTheme();
  const [open, setOpen] = useState(false);
 // const [position, setPosition] = useState({ top: 0, left: 0 });

  const handleMenu = (event: { currentTarget: { getBoundingClientRect: () => any; }; }) => {
    //const rect = event.currentTarget.getBoundingClientRect();
   /* setPosition({
      top: rect.top + window.scrollY,
      left: rect.left + window.scrollX,
    });*/
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const GradientIcon = (props: JSX.IntrinsicAttributes & { component: React.ElementType<any, keyof React.JSX.IntrinsicElements>; } & SvgIconOwnProps & CommonProps & Omit<any, "children" | "color" | "fontSize" | "shapeRendering" | "sx" | "style" | "className" | "viewBox" | "classes" | "htmlColor" | "inheritViewBox" | "titleAccess">) => (
    <SvgIcon {...props}>
      <defs>
        <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%"> {/* Cambiado a lowercase */}
          <stop offset="0%" style={{ stopColor: "#5AC3D1", stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: "#00BCD4", stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <path
        fill="url(#gradient1)"
        d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zM6.023 15.416C7.491 17.606 9.695 19 12.16 19c2.464 0 4.669-1.393 6.136-3.584A8.968 8.968 0 0 0 12.16 13a8.968 8.968 0 0 0-6.137 2.416zM12 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
      />
    </SvgIcon>
  );
  

  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div>
      <IconButton edge="end" onClick={handleMenu} sx={{ color: "white" }}>
        <AccountCircle sx={{ fontSize: 40 }} />
      </IconButton>
      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: isSmallScreen ? "center" : "flex-start",
          justifyContent: isSmallScreen ? "center" : "flex-end",
        }}
      >
        <Box
          sx={{
            position: isSmallScreen ? "absolute" : "relative",
            top: isSmallScreen ? "50%" : "56px",
            right: isSmallScreen ? "auto" : "16px",
            left: isSmallScreen ? "50%" : "auto",
            transform: isSmallScreen ? "translate(-50%, -50%)" : "none",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "19%",
              right: "35%",
              width: 90,
              height: 90,
              bgcolor: "#FFFFFF",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <GradientIcon sx={{ fontSize: 100 }} component={"svg"} />
          </Box>
          <Paper
            sx={{
              width: "300px",
              bgcolor: "#00A3A8",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "50px 0",
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
            }}
            elevation={3}
          ></Paper>
          <Paper
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
              bgcolor: "#FFFFFF",
              paddingTop: 5,
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
            }}
            elevation={3}
          >
            <Typography variant="subtitle1" sx={{ color: "#000000", mt: 2 }}>
            {user.getNombre()+" "+user.getApellido()}
            </Typography>
            <Typography variant="body2" sx={{ color: "#000000" }}>
              {user.getEmail()}
            </Typography>
            <Button
              variant="contained"
              color="primary"
              fullWidth
              onClick={onLogoutFromMenu}
              sx={{
                borderRadius: 2,
                padding: "8px 16px",
                bgcolor: "#0288D1",
                margin: "20px 0",
                width: "80%",
                color: "white",
                "&:hover": { bgcolor: "#0277BD" },
              }}
            >
              CERRAR SESIÓN
            </Button>
          </Paper>
        </Box>
      </Modal>
    </div>
  );
};

export default UsrMenu;